import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toFix'
})
export class ToFixPipe implements PipeTransform {
  transform(value: number): any {
    return value.toFixed(2);
  }
}
